import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../../requestOptions';

export type CategoryPlanApplyData = Readonly<{
  run_id: number;
  applied: number[];
  reused: number[];
  skipped_no_grouping: number[];
  suggestions_applied: number;
}>;

export async function applyCategoryPlanRun(
  scope: RequestScope,
  args: { runId: number },
  options: WriteRequestOptions
): Promise<ChannelApiResponse<CategoryPlanApplyData>> {
  try {
    const res = await scopedChannelApi(scope).post<CategoryPlanApplyData>(
      `atts/category-plan/runs/${args.runId}/apply`,
      {},
      { ...options, headers: buildAsturHeaders() }
    );

    if (
      !res.data ||
      !Array.isArray(res.data.applied) ||
      !Array.isArray(res.data.reused) ||
      !Array.isArray(res.data.skipped_no_grouping) ||
      typeof res.data.suggestions_applied !== 'number'
    ) {
      throw new Error('Invalid apply response');
    }

    return { data: res.data, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
